// Footer.jsx — koyu alt bilgi: marka, uygulama rozetleri, bağlantı sütunları, dil seçici.

import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n';
import { SOCIAL, CONTACT_EMAIL } from '../config/links';
import StoreBadges from './StoreBadges';

export default function Footer() {
  const { t, to, lang } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row g-4">
          <div className="col-12 col-lg-4">
            <Link to={to('home')} className="brand mb-3">
              <span className="brand-mark jp" aria-hidden="true">将</span>
              <span>
                <span className="brand-name">{t('brand')}</span>
                <span className="brand-tag">{t('brandTag')}</span>
              </span>
            </Link>
            <p className="small mt-3 mb-3">{t('footer.about')}</p>
            <div className="small fw-bold text-white mb-2">{t('footer.getApps')}</div>
            <StoreBadges medium="footer" />
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <h3>{t('footer.play')}</h3>
            <ul>
              <li><Link to={to('play')}>{t('nav.play')}</Link></li>
              <li><Link to={to('puzzles')}>{t('nav.puzzles')}</Link></li>
              <li><Link to={to('arena')}>{t('nav.arena')}</Link></li>
              <li><Link to={to('leaderboard')}>{t('nav.leaderboard')}</Link></li>
              <li><Link to={to('apps')}>{t('nav.apps')}</Link></li>
            </ul>
          </div>

          <div className="col-6 col-md-4 col-lg-3">
            <h3>{t('footer.learn')}</h3>
            <ul>
              <li><Link to={to('howto')}>{t('nav.howto')}</Link></li>
              <li><Link to={to('pieces')}>{t('nav.pieces')}</Link></li>
              <li><Link to={to('rules')}>{t('nav.rules')}</Link></li>
              <li><Link to={to('academy')}>{t('nav.academy')}</Link></li>
              <li><Link to={to('faq')}>{t('nav.faq')}</Link></li>
            </ul>
          </div>

          <div className="col-12 col-md-4 col-lg-3">
            <h3>{t('footer.community')}</h3>
            <ul>
              <li><a href={SOCIAL.youtube} target="_blank" rel="noopener noreferrer">YouTube</a></li>
              <li><a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href={SOCIAL.blog} target="_blank" rel="noopener noreferrer">{t('footer.blog')}</a></li>
              <li><Link to={to('contact')}>{t('nav.contact')}</Link></li>
              <li><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></li>
            </ul>
          </div>
        </div>

        <div className="bottom d-flex flex-wrap justify-content-between gap-2">
          <span>© {year} {t('brand')}. {t('footer.rights')}</span>
          <span>
            <Link to="/" hrefLang="tr" className={lang === 'tr' ? 'text-white fw-bold' : ''}>Türkçe</Link>
            {' · '}
            <Link to="/en" hrefLang="en" className={lang === 'en' ? 'text-white fw-bold' : ''}>English</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
